export const endpoint =
  "https://productdirectorytestservice.gs1ng.org/v1/api/Product/getall?";

// export const productListURL = `${endpoint}/products/`;
